/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { isType, setOnline, setLoading } from "../actions";
import { Context } from "../../types/RootState";

const initialState: Context = {
    isOnline: navigator.onLine,
    isLoading: false,
};

export default function contextReducer(state: Context = initialState, action): Context {
    if (isType(action, setOnline)) {
        return {
            ...state,
            isOnline: action.payload,
        };
    }
    if (isType(action, setLoading)) {
        return {
            ...state,
            isLoading: action.payload,
        };
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/context.reducer.ts